import React, { ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'success' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  icon?: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  icon,
  children,
  className = '',
  ...props
}) => {
  const baseClass = 'btn';
  const variantClass = `btn-${variant}`;
  const sizeClass = size !== 'md' ? `btn-${size}` : '';
  const iconOnlyClass = !children && icon ? 'btn-icon' : '';

  return (
    <button
      className={`${baseClass} ${variantClass} ${sizeClass} ${iconOnlyClass} ${className}`.trim()}
      {...props}
    >
      {icon && <span>{icon}</span>}
      {children}
    </button>
  );
};
